import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import ChartControlls from "../../ChartControlls";
import ChartTeamBox from "../../ChartTeamBox";
import { cn, getTeamPosition } from "../../../../utils/utils";
import ResultsColumnCharts from "../../ResultsColumnCharts";
import ChartTeamMatchBox from "../../ChartTeamMatchBox";
import CompanyImage from "../../../../assets/images/final.png";
import LeaguesIcon from "../../../../assets/icons/LeaguesIcon";
import ShareIcon from "../../../../assets/icons/ShareIcon";
import logo from "../../../../assets/images/Logo.png";
import CloseIcon from "../../../../assets/icons/DELETE __ DARK.svg";
import { toJpeg } from "html-to-image";
import Winner from "../../../../assets/icons/winner.svg";
import { useRef } from "react";
import ImageIcon from "../../../global/ImageIcon";
import { ChevronRight } from "lucide-react";
const RoundOf8 = ({
  groupedMatches,
  generalINfo,
  isShareMode,
  type
}: {
  groupedMatches: { [key: string]: any };
  generalINfo: any;
  isShareMode:boolean;
  type: "leagues" | "tournaments";
}) => {
    const sortPhasesFn = (data: any) => {
  return data.sort(
    (a: any, b: any) =>
      parseInt(a.match_code.substr(1)) - parseInt(b.match_code.substr(1))
  );
};
const swap = (arr: any,fromIndex: number,toIndex: number)=>{
  const newArr = [...arr]
  var temp = newArr[fromIndex];
  newArr[fromIndex] = newArr[toIndex];
  newArr[toIndex] = temp;
  return newArr
}
const param = useParams()
  const [searchParams] = useSearchParams();
 const navigate = useNavigate()
;

let leftKnockoutsPhase = groupedMatches["Quarter Final"].slice(0,2)
 // console.log(leftKnockoutsPhase);
  
  let rightKnockoutsPhase = groupedMatches["Quarter Final"].slice(2,4)
 if(+param.id! === 483){
  
  
     leftKnockoutsPhase = swap(groupedMatches["Quarter Final"],1,3).slice(0,2)
 // console.log(leftKnockoutsPhase);
  
   rightKnockoutsPhase = swap(groupedMatches["Quarter Final"],1,3).slice(2,4)
 }
 if(+param.id! === 484){
  
  
     leftKnockoutsPhase = swap(groupedMatches["Quarter Final"],0,3).slice(0,2)
 // console.log(leftKnockoutsPhase);
  
   rightKnockoutsPhase = swap(groupedMatches["Quarter Final"],0,3).slice(2,4)
 }
  
    //console.log(rightKnockoutsPhase);
  const LeftSemiFinalPhases = groupedMatches["Semi Final"].slice(0,1)
  const RightSemiFinalPhases = groupedMatches["Semi Final"].slice(1,2)
  const finalMatch = groupedMatches?.Final?.find(
    (match: any) => match.final_type === 'winner'
  );
  const thirdPlaceMatch = groupedMatches?.["3rd Place"]?.find(
    (match: any) => match.final_type === 'loser'
  );
  const elementRef = useRef(null);
  const htmlToImageConvert = () => {
    //@ts-ignore
    toJpeg(elementRef.current, { cacheBust: false })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "trophy.jpg";
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div className="w-full h-dvh flex flex-col  bg-white overflow-y-auto customScroll min-w-[1200px]">
       {!isShareMode && (
        <div className="header py-2 px-2 bg-primary text-white flex gap-4 items-center justify-between sticky">
          <div className=" flex gap-4 items-center flex-1">
            <ImageIcon Icon={LeaguesIcon} width={40} height={40} />
            <div className="flex gap-2 items-center">
              <span
                className="font-bold text-lg cursor-pointer"
                onClick={() => navigate("/competitive/" + type)}
              >
                {type}
              </span>{" "}
              <ChevronRight size={15} />{" "}
              <span className="font-bold text-lg">Final</span>
            </div>
          </div>
          <div className="logo flex justify-center flex-[3]">
            <img loading="lazy" src={logo} alt="" />
          </div>
          <div className="close flex-1 flex justify-end">
            <img
              loading="lazy"
              src={CloseIcon}
              alt=""
              width={28}
              height={28}
              className="cursor-pointer"
              onClick={() => navigate("/competitive/" + type)}
            />
          </div>
        </div>
      )}
      <div className="relative w-full h-fit ">
        {groupedMatches && (
          <div className="flex justify-between absolute z-50 p-6 items-center w-full ">
            <div className="club flex items-center gap-2 flex-1">
              <img
                loading="lazy"
                src={generalINfo.club_id.logo}
                alt=""
                width={100}
                height={100}
                className="rounded-full w-[80px] h-[80px] object-cover"
              />
              <span className="text-lg text-primary dark:text-white font-bold">
                {generalINfo.club_id.name}
              </span>
            </div>
            <div className="p-2 px-4  bg-white rounded-l-full rounded-r-full min-w-[200px] flex flex-col border border-primary flex-1 max-w-[250px]">
              <div className="flex gap-4 pr-10">
                {generalINfo?.poster_url && (
                  <img
                    loading="lazy"
                    src={generalINfo?.poster_url}
                    alt=""
                    className="rounded-full w-[60px] h-[60px] object-cover bg-red-100"
                  />
                )}
                <div
                  className={cn(
                    "flex  gap-2",
                    generalINfo?.poster_url && "flex-col"
                  )}
                >
                  <h3>{searchParams.get("name")}</h3>
                  <p>{generalINfo?.tournament_type}</p>
                </div>
              </div>
            </div>
            <div className="sponsors flex items-center gap-2 flex-1 justify-end ">
              {generalINfo.sponsor_ids.map((item: any) => {
                if (item.logo_url) {
                  return (
                    <img
                      loading="lazy"
                      src={item.logo_url}
                      alt=""
                      width={40}
                      height={40}
                      className="rounded-full w-[80px] h-[80px] object-cover border border-primary"
                    />
                  );
                } else return null;
              })}
            </div>
          </div>
        )}
        {groupedMatches && (
          <div
            ref={elementRef}
            className="relative w-full  grid grid-cols-10 grid-rows-1  bg-white pt-[150px] pb-[100px]  h-fit"
          >
            <img
              loading="lazy"
              src={CompanyImage}
              alt=""
              className="absolute w-full h-full object-contain "
            />
            <div className=" col-span-3  flex flex-col justify-around items-center gap-1 font-bold text-lg  rounded-lg text-primary dark:text-white">
              {groupedMatches["Quarter Final"] &&
                new Array(2).fill(0).map((item, index: number) => {
                  return (
                    <div className="h-[30vh] min-h-[170px]  pl-5 w-full rounded-lg font-bold text-lg text-center flex items-center text-primary dark:text-white relative ">
                      <div className="h-[20vh] min-h-[120px]  pl-5 w-[70%] rounded-lg font-bold text-lg text-center flex items-center text-primary dark:text-white relative flex-col gap-4">
                        <ChartTeamBox
                          data={leftKnockoutsPhase[index]}
                          type="Quarter"
                          isGuest={false}
                        />
                        <ChartTeamBox
                          data={leftKnockoutsPhase[index]}
                          type="Quarter"
                          isGuest={true}
                        />
                      </div>
                      <div className="h-[12vh] min-h-[80px]  border border-secondary w-[30%] border-l-0 rounded-md rounded-l-none relative text-sm">
                        {groupedMatches["Quarter Final"] &&
                          leftKnockoutsPhase[index].winner && (
                            <ul className="absolute flex items-center -top-7 left-4 text-[#747474] font-digital gap-1 text-lg">
                              <li>
                                {leftKnockoutsPhase[index].team_line_ids[0]?.score_1}{" "}
                              </li>
                              {parseInt(leftKnockoutsPhase[index].set_per_match) !==
                                1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      leftKnockoutsPhase[index].team_line_ids[0]
                                        ?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      leftKnockoutsPhase[index].team_line_ids[0]
                                        ?.score_3
                                    }
                                  </li>
                                </>
                              )}
                              {leftKnockoutsPhase[index].winner?.id &&
                                leftKnockoutsPhase[index].winner?.id ===
                                  leftKnockoutsPhase[index].team_line_ids[0]?.team_id
                                    ?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                            </ul>
                          )}
                        {groupedMatches["Quarter Final"] &&
                          leftKnockoutsPhase[index].winner && (
                            <ul className="absolute flex items-center bottom-0 left-4 text-[#747474]  font-digital gap-1 text-lg">
                              <li>
                                {leftKnockoutsPhase[index].team_line_ids[1]?.score_1}{" "}
                              </li>

                              {parseInt(leftKnockoutsPhase[index].set_per_match) !==
                                1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      leftKnockoutsPhase[index].team_line_ids[1]
                                        ?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      leftKnockoutsPhase[index].team_line_ids[1]
                                        ?.score_3
                                    }
                                  </li>
                                </>
                              )}
                              {leftKnockoutsPhase[index].winner?.id &&
                                leftKnockoutsPhase[index].winner?.id ===
                                  leftKnockoutsPhase[index].team_line_ids[1]?.team_id
                                    ?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                            </ul>
                          )}
                      </div>
                    </div>
                  );
                })}
            </div>

           
            <ResultsColumnCharts
              currentStage={LeftSemiFinalPhases}
              previousStage={leftKnockoutsPhase}
              rowsNumber={1}
              baseHight={30}
            />

            <div className="col-span-2  flex flex-col justify-around items-center gap-1 font-bold text-lg  rounded-lg text-primary dark:text-white relative">
              <div className="h-[20vh]   font-bold text-lg  w-full mx-auto  rounded-md flex justify-center items-center text-primary dark:text-white  z-20 relative">
                <div className="h-full w-[80%] mx-auto z-20  ">
                  <div className="h-full z-20">
                    <ChartTeamMatchBox
                      data={finalMatch}
                      getTeamPosition={getTeamPosition}
                      SemiFinalData={groupedMatches["Semi Final"]}
                      type="Quarter"
                      isWinner={true}
                    />
                  </div>
                  <div className="mt-[max(10vh,60px)] h-full w-full mx-auto relative">
                    <ChartTeamMatchBox
                      getTeamPosition={getTeamPosition}
                      SemiFinalData={groupedMatches["Semi Final"]}
                      data={thirdPlaceMatch}
                      type="Quarter"
                      isWinner={false}
                      placeType="third place"
                    />
                    <div className="absolute -left-[5%] bottom-[50%] w-[110%] h-[calc(100%+max(10vh,60px))] border border-[#cccccc] z-10 border-t-0"></div>
                  </div>
                </div>
              </div>
              <div className="absolute top-[50%] w-[100%] h-[1px] border border-[#cccccc] z-10 "></div>
            </div>

            <ResultsColumnCharts
              currentStage={RightSemiFinalPhases}
              previousStage={rightKnockoutsPhase}
              rowsNumber={1}
              postion={"right"}
              baseHight={30}
            />
            

            <div className=" col-span-3  flex flex-col justify-around items-center gap-1 rounded-lg font-bold text-lg text-primary dark:text-white">
              {groupedMatches["Quarter Final"] &&
                new Array(2).fill(0).map((item, index: number) => {
                  return (
                    <div className="h-[30vh] min-h-[170px]  pr-5 w-full rounded-lg font-bold text-lg text-center flex items-center text-primary dark:text-white relative ">
                      <div className="h-[12vh] min-h-[80px]  border border-secondary w-[30%] border-r-0 rounded-md rounded-l-none relative text-sm">
                        {groupedMatches["Quarter Final"] &&
                          rightKnockoutsPhase[index].winner && (
                            <ul className="absolute flex items-center -top-7 right-4 text-[#747474] font-digital gap-1 text-lg">
                              <li>
                                {rightKnockoutsPhase[index].team_line_ids[0]?.score_1}{" "}
                              </li>
                              {parseInt(rightKnockoutsPhase[index].set_per_match) !==
                                1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      rightKnockoutsPhase[index].team_line_ids[0]
                                        ?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      rightKnockoutsPhase[index].team_line_ids[0]
                                        ?.score_3
                                    }
                                  </li>
                                </>
                              )}
                              {rightKnockoutsPhase[index].winner?.id &&
                                rightKnockoutsPhase[index].winner?.id ===
                                  rightKnockoutsPhase[index].team_line_ids[0]?.team_id
                                    ?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                            </ul>
                          )}
                        {groupedMatches["Quarter Final"] &&
                          rightKnockoutsPhase[index].winner && (
                            <ul className="absolute flex items-center bottom-0 right-4 text-[#747474]  font-digital gap-1 text-lg">
                              <li>
                                {rightKnockoutsPhase[index].team_line_ids[1]?.score_1}{" "}
                              </li>

                              {parseInt(rightKnockoutsPhase[index].set_per_match) !==
                                1 && (
                                <>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      rightKnockoutsPhase[index].team_line_ids[1]
                                        ?.score_2
                                    }{" "}
                                  </li>
                                  <li className="font-sans">-</li>
                                  <li>
                                    {
                                      rightKnockoutsPhase[index].team_line_ids[1]
                                        ?.score_3
                                    }
                                  </li>
                                </>
                              )}
                              {rightKnockoutsPhase[index].winner?.id &&
                                rightKnockoutsPhase[index].winner?.id ===
                                  rightKnockoutsPhase[index].team_line_ids[1]?.team_id
                                    ?.id && (
                                  <li>
                                    <img
                                      loading="lazy"
                                      src={Winner}
                                      alt=""
                                      width={15}
                                      height={15}
                                    />
                                  </li>
                                )}
                            </ul>
                          )}
                      </div>
                      <div className="h-[20vh] min-h-[120px]  pr-5 w-[70%] rounded-lg font-bold text-lg text-center flex items-center text-primary dark:text-white relative flex-col gap-4">
                        <ChartTeamBox
                          data={rightKnockoutsPhase[index]}
                          type="Quarter"
                          isGuest={false}
                        />
                        <ChartTeamBox
                          data={rightKnockoutsPhase[index]}
                          type="Quarter"
                          isGuest={true}
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </div>

      <ChartControlls htmlToImageConvertFn={htmlToImageConvert} />
    </div>
  );
};
export default RoundOf8;